var _style, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSidebarUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.316,7.841c1.055-0.506,1.748-1.584,1.748-2.757C11.064,3.395,9.689,2.02,8,2.02S4.936,3.395,4.936,5.084 c0,1.173,0.692,2.251,1.748,2.757c-2.088,0.76-3.423,3.342-3.423,6.676v0.298h9.479v-0.298C12.739,11.183,11.405,8.601,9.316,7.841z  M8,8.204c2.357,0,4.05,2.469,4.139,6.015H3.861C3.95,10.673,5.643,8.204,8,8.204z M8,2.615c1.361,0,2.468,1.107,2.468,2.469 c0,1.36-1.107,2.468-2.468,2.468S5.532,6.445,5.532,5.084C5.532,3.723,6.639,2.615,8,2.615z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 16,
    height: 16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSidebarUser);
export default __webpack_public_path__ + "static/media/icon-sidebar-user.e7525b2ab2f9533dea2ed64a08f8e4b7.svg";
export { ForwardRef as ReactComponent };